export default "__VITE_ASSET__BVxlktRG__"